import React from 'react';
import { useSelector } from 'react-redux';

import { VipState } from '../../../reducers';
import { Box, ContentWrapper } from '../common';
import Header from './header';
import ExtendedReport from './report/extended-report';
import BasicReport from './report/basic-report';
import Footer from './footer';

export const VHCPanel: React.FC = () => {
    const {
        vhcData = {
            vrm: '',
            extended: false,
            notCatCorD: false,
            notCatSorN: false,
            notImported: false,
            originalNumberPlate: false,
            originalColour: false,
        }
    } = useSelector((state: VipState) => state);

    const propsToPassIntoComponents = {
        extendedVhc: vhcData.extended,
        notCatCD: vhcData.notCatCorD,
        notImported: vhcData.notImported,
        originalNumberPlate: vhcData.originalNumberPlate,
        originalColour: vhcData.originalColour,
        hpiUrl: `https://gumtree.hpicheck.com/${vhcData.vrm ? `?vrm=${vhcData.vrm}&enc=true` : ''}`,
        notCatSN: vhcData.notCatSorN,
    };

    return (
        <Box>
            <Header />
            <ContentWrapper>
                {vhcData.extended ? <ExtendedReport {...propsToPassIntoComponents} /> : <BasicReport />}
            </ContentWrapper>
            <Footer hpiUrl={propsToPassIntoComponents.hpiUrl} />
        </Box>
    );
};

export default VHCPanel;
